module.exports = __webpack_public_path__ + "static/media/cadastral-advice.d1f9eaa0.svg";